export default "__VITE_ASSET__CEgxm8wF__"